import React, { useCallback, useEffect, useRef } from 'react';

import styles from './styles.module.scss';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
}

const Textarea = (props: TextareaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if(!ref.current) return;
    ref.current.style.height = 'auto';
    ref.current.style.height = `${ref.current.scrollHeight}px`;
    props.onChange?.call(null, e);
  }, [ref, props.onChange]);

  const copyProps = { ...props };

  delete copyProps.onChange;
  delete copyProps.value;

  useEffect(() => {
    if(!ref.current) return;
    ref.current.style.height = 'auto';
    ref.current.style.height = `${ref.current.scrollHeight}px`;
  }, [ref, props.value]);

  return <textarea ref={ref} className={styles.textarea} {...props} rows={1} value={props.value} onChange={handleChange} />;
}

export default Textarea;